module.exports = __webpack_public_path__ + "img/employee-CV.6f2ca3a2.svg";